import NotificationTypes from './notification.types'

const INITIAL_STATE = {
	data: null,
	total: 0,
	page: 1,
	selectedNotification: null,
	lastAdded: null,
}

const NotificationReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case NotificationTypes.GET_NOTIFICATIONS:
			return {
				...state,
				...payload,
			}
		case NotificationTypes.SELECT_NOTIFICATIONS:
			return {
				...state,
				selectedNotification: payload,
			}
		case NotificationTypes.ADD_NOTIFICATION:
			return {
				...state,
				lastAdded: payload,
			}
		default:
			return state
	}
}

export default NotificationReducer
